// Products module API helpers
import { api, backendOrigin } from "@/lib/api";

export async function listProducts({ search = "", filter = "all", sort = "updated_desc", cursor = null, limit = 100 } = {}) {
  const params = { search, filter, sort, cursor: cursor || undefined, limit };
  const { data } = await api.get("/products/", { params });
  return data;
}

export async function getProduct(productId) {
  const { data } = await api.get(`/products/${encodeURIComponent(productId)}`);
  return data;
}

export async function updateProduct(productId, body) {
  const { data } = await api.put(`/products/${encodeURIComponent(productId)}`, body);
  return data;
}

export async function syncProducts(full = false, limit = 250) {
  const { data } = await api.post("/products/sync", { full, limit });
  return data;
}

export async function getSyncStatus() {
  const { data } = await api.get("/products/sync/status");
  return data;
}

export async function getFacets() {
  const { data } = await api.get("/products/meta/facets");
  return data;
}

export async function bulkPrice({ product_ids, mode, value, field = "price" }) {
  const { data } = await api.post("/products/bulk/price", { product_ids, mode, value, field });
  return data;
}

export async function bulkStock({ product_ids, mode, value }) {
  const { data } = await api.post("/products/bulk/stock", { product_ids, mode, value });
  return data;
}

export async function bulkStatus({ product_ids, status }) {
  const { data } = await api.post("/products/bulk/status", { product_ids, status });
  return data;
}

export async function bulkTags({ product_ids, add = [], remove = [] }) {
  const { data } = await api.post("/products/bulk/tags", { product_ids, add, remove });
  return data;
}

export function exportCsvUrl(ids = []) {
  // returns a backend URL the operator can hit directly
  const base = backendOrigin();
  const q = ids.length ? `?ids=${ids.join(",")}` : "";
  return `${base}/api/products/export/csv${q}`;
}
